import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-productdetails',
  templateUrl: './productdetails.component.html',
  styleUrls: ['./productdetails.component.css']
})
export class ProductdetailsComponent implements OnInit {

 
  @Input() productid: number = 0

  @Input() productBO: any = {}

  @Input() variationColl: any = []

  selectvariation :any=""
  
  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private activeModal: NgbActiveModal) {
  
  }

  
  ngOnInit() {
   

  }

  fnVariationBtnClick(sizeid) {
    this.selectvariation = sizeid;
  }
 
  public cartClick() {

    this.emitData.emit("CART");
    this.activeModal.close(false);

  }

  public decline() {


    this.activeModal.close(false);
  }
}
